import React from 'react';
import Dialog from 'react-toolbox/lib/dialog';
import Button from '../../../../../../common/components/Button';
import MembersOnly from '../MembersOnly';
import AssociationForm from '../AssociationForm';

class MembersOnlyEvent extends React.Component {
  static dialogTypes = {
    associate: 'associate',
    orgExists: 'orgExists',
  };
  state = {
    dialogs: {
      associate: false,
      orgExists: false,
      orgText: '',
    },
  };

  toggleDialog = (name, extraValues = {}) => {
    this.setState(prevState => ({
      dialogs: {
        ...prevState.dialogs,
        [name]: !prevState.dialogs[name],
        ...extraValues,
      },
    }));
  };

  closeAllDialogs = () => {
    const {closeDialog} = this.props;
    if (closeDialog) {
      closeDialog();
    }
    this.toggleDialog(MembersOnlyEvent.dialogTypes.associate);
  }

  render() {
    const { dialogs } = this.state;
    const { currentCustomer, currentUser, event } = this.props;
    const dialogTypes = MembersOnlyEvent.dialogTypes;

    return (
      <div>
        <MembersOnly
          title="Member Only Event"
          text={
            'This event is for active NFIB members. If you are an NFIB member ' +
              'and cannot view the registration page, please call 1-800-NFIB-NOW or contact the ' +
              'event manager at the number in the event description.'
          }
          organization={currentCustomer && currentCustomer.organization}
          currentUser={currentUser}
          event={event}
          handleJoinExistingOrg={message =>
            this.toggleDialog(dialogTypes.orgExists, { orgText: message })}
          handleAssociateClick={() => this.toggleDialog(dialogTypes.associate)}
        />
        <Dialog
          active={dialogs[dialogTypes.associate]}
          onEscKeyDown={() => this.toggleDialog(dialogTypes.associate)}
          onOverlayClick={() => this.toggleDialog(dialogTypes.associate)}
          title="Associate with an Organization"
        >
          <AssociationForm
            closeDialog={() => this.closeAllDialogs()}
          />
          <Button
            style={{
              width: '100%',
              marginTop: '8px',
              marginLeft: '0px',
              marginRight: '0px',
            }}
            label="Cancel"
            onClick={() => this.toggleDialog(dialogTypes.associate)}
          />
        </Dialog>
        <Dialog
          actions={[
            {
              label: 'Close',
              onClick: () => this.toggleDialog(dialogTypes.orgExists),
            },
          ]}
          active={dialogs[dialogTypes.orgExists]}
          onEscKeyDown={() => this.toggleDialog(dialogTypes.orgExists)}
          onOverlayClick={() => this.toggleDialog(dialogTypes.orgExists)}
        >
          <div style={{ fontSize: '1.6rem' }}>{dialogs.orgText}</div>
        </Dialog>
      </div>
    );
  }
}

export default MembersOnlyEvent;



// WEBPACK FOOTER //
// ./src/App/events/Views/Detail/RegistrationCard/Availability/MembersOnlyEvent.js